import React from "react";
import * as appAction from "../actions/appactions";
import { useDispatch, useSelector } from "react-redux";

export default function LoadingIndicator(props) {
  const state = useSelector((state) => state.appReducer);

  if (state.loadingIndicatorCounter > 0) {
    return (
      <div className="loading-progress-container">
        <div className="loading-progress-overlay"></div>
        <div className="loading-progress-message-container">
        <div class="spinner-border avatar-md text-primary" role="status"></div> <p> Loading...</p>
        </div>
      </div>
    );
  }
}
